
import { Component, Mixins, Watch } from "vue-property-decorator";
import { FormatReference } from "../../../../domain/format";
import { Patient } from "../../../../domain/patient";
import { default as NewDocumentEditorBaseMixin } from "./NewDocumentEditorBaseMixin.vue";

@Component({
})
export default class NewDocumentEditorMixin extends Mixins(NewDocumentEditorBaseMixin) {
  @Watch("patient")
  onPatientUpdated(newValue: Patient, oldValue: Patient): void {
    this.loadNewDocument();
  }

  @Watch("format")
  onFormatUpdated(newValue: FormatReference, oldValue: FormatReference): void {
    this.loadNewDocument();
  }
}
